jQuery(document).ready(function ($) {
    ({
        init: function () {
            this.toggle_tab_list();
            this.qty_control_action(); 
            this.xs_image_slider();
            this.thumb_slider();
            $('[data-fancybox]').fancybox({
                loop : true
            });
        },
        toggle_tab_list:function(){
            var section = $('.product-tab-info');
            var nav = section.find('.nav-item'); 
            nav.first().addClass('active');
            section.find('.content-item').first().show();
            nav.click(function(){
                var index = $(this).index();
                var parents = $(this).parents('.product-tab-info');
                if(!$(this).hasClass('active')){
                    parents.find('.nav-item').removeClass('active');
                    $(this).addClass('active');
                    parents.find('.content-item').slideUp();
                    parents.find('.content-item').eq(index).slideDown();
                    $("html,body").animate({
                        scrollTop: section.offset().top - 50
                    }, 500)
                }
            })
        },
        qty_control_action:function(){
            var control = $('.qty-box .control');
            var qty = $('.qty-box input');
            control.click(function(){
                var val = parseInt(qty.val()) ;
                if($(this).hasClass('control-down')){
                    if(val > 1){
                        qty.val(val-1);
                    }
                }
                if($(this).hasClass('control-up')){
                    qty.val(val+1);
                }
                
            })
        },
        thumb_slider: function () {
            var slider = $('.thumbnails-wrapper-list .thumbnail-list');
            var item = slider.find('.thumbnail-item');
            if (item.length > 4) {
                slider.removeClass('row');
                slider.slick({
                    arrows: false,
                    dots: true,
                    infinite: false,
                    speed: 800,
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    responsive: [{
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
            }
        },
        xs_image_slider: function () {
            var section = $('.xs-product-image');
            var slider = section.find('.image-list');
            var item = slider.find('.image-item'); 
            if (item.length > 1) {
                slider.bxSlider({
                    speed: 1200,
                    pause: 9000,
                    auto:false,
                    control:false,
                    onSliderLoad: function (current) {
                        section.addClass('active');
                        var pageritem = section.find('.bx-pager-item');
                        var len = pageritem.length;
                        pageritem.each(function () {
                            var index = $(this).index();
                            $(this).css('width', 100 / len * (index + 1) + '%')
                        })
                    },
                });
            }else{
                section.addClass('active');
            }
        },
        load: function () {
            $window.load(function () {

            })
        },
        resize: function () {
            $window.resize(function () {
                
            })
        }
    }).init()
});